<template>
    <div style="padding: 12px" :style="{backgroundColor:((filtered.length >= 2)?'#F7F9F9':'transparent')}">
        <FilterInput :placeholder="$t('products.search')" v-model="filtered"/>
    </div>
        <div class="form-row flex-row" style="padding: 12px;text-align: left">
        <div class="form-row-element">
            <label class="category-label">{{ $t('products.lowstockToggle') }}</label>
        </div>
        <div class="form-row" style="display: flex; align-content:flex-end">
            <Toggle v-model="lowStockToggle"
                    :colors="colors"
            />
        </div>
    </div>

    <Spinner v-if="loading" :size="24"/>
    <div v-else-if="line_type === constants.LINE_PROFILING || line_type === constants.LINE_ELEVATED_HOST_GIFT">
        <ProductList :mode="mode"  :custlist="custlist"
                     @add-to-cart-clicked="addToCartClicked"
                     :line_type="line_type"
                     :party="party"
                     @remove-from-cart-clicked="removeFromCartClicked"
                     @make-reservation-clicked="makeReservationClicked"
                     @release-reservation-clicked="releaseReservationClicked"
                     @add-focus-product="addFocusProduct"
                     @remove-focus-product="removeFocusProduct"
                     @make-backorder-clicked="makeBackorderClicked"
                     @cancel-backorder-clicked="cancelBackorderClicked"
                     @make-return-clicked="makeReturnClicked"
                     @cancel-return-clicked="cancelReturnClicked"
        />
    </div>
    <div v-else>
        <div class="category-element" v-for="category in categories" :key="(category.id + 3*prodTick )"
             :style="{
                 backgroundColor:((isExpanded(category) || isFiltered(category))?'#F7F9F9':'transparent'),
                 borderTop:((filtered.length >= 2 || lowStockToggle)?'0px solid #43515255':'1px solid #43515255')
              }"
        >
            <div class="category-heading"  @click="toggleExpand(category.id)">
                <div class="category-label" :style="{color:((filtered.length >= 2 || lowStockToggle)?'#435152':'#435152')}">
                    {{ category.name }}
                </div>
                <img class="category-toggler" src="@/assets/TogglerArrow.svg"
                     v-if="filtered.length < 2 && !lowStockToggle"
                     :style="{transform:(isExpanded(category)?'rotate(90deg)':'rotate(0deg)')}"
                >
            </div>

            <div class="product-list-wrapper" v-if="isExpanded(category) || isFiltered(category) " :key="prodTick+category.id">

                <ProductList :mode="mode" :products="products(category)" :custlist="custlist"
                             @add-to-cart-clicked="addToCartClicked"
                             :line_type="line_type"
                             :filtered="getFilteringState(filtered, category.filteredStatus)"
                             :party="party"
                             :key="2*prodTick+category.id"
                             @remove-from-cart-clicked="removeFromCartClicked"
                             @make-reservation-clicked="makeReservationClicked"
                             @release-reservation-clicked="releaseReservationClicked"
                             @add-focus-product="addFocusProduct"
                             @remove-focus-product="removeFocusProduct"
                             @make-backorder-clicked="makeBackorderClicked"
                             @cancel-backorder-clicked="cancelBackorderClicked"
                             @make-return-clicked="makeReturnClicked"
                             @cancel-return-clicked="cancelReturnClicked"
                             @add-replacement-product="addReplacementProduct"


                />
            </div>
       </div>
    </div>
</template>

<script>
 import Spinner from '@/components/core/Spinner.vue'
 import { ref, watch } from 'vue'
 import { useStore } from 'vuex'
 import ProductList from "./ProductList.vue"
 import FilterInput from "@/components/forms/filter/FilterInput.vue"
 import * as constants from '@/store/constants'
 import Toggle from "@vueform/toggle";

 export default {
     name: "CategoryList",
     components: { FilterInput, ProductList, Spinner, Toggle },
     data(){
         return {
             expanded: [],
             constants: constants,
             colors: {
                 background: {
                     on: '#435152',
                     off: '#FFFFFF',
                     disabled: '#FFFFFF'
                 },
                 handle: {
                     on: '#17bdbd',
                     off: '#7E9495',
                     disabled: '#FFFFFF'
                 }
             },
         }
     },
     props:{
         mode:{
             type:String,
             default:'list'
         },
         custlist:null,
         party:null,
         tick: {type: Number, default:0},
         line_type: {type: Number, default:1},
     },
     emits:[
         'remove-from-cart-clicked', 'add-to-cart-clicked',
         'make-reservation-clicked','release-reservation-clicked',
         'make-backorder-clicked','cancel-backorder-clicked',
         'make-return-clicked','cancel-return-clicked',
         'add-focus-product','remove-focus-product','add-replacement-product'
     ],
     methods:{
         addToCartClicked(custId, sku){
             this.$emit('add-to-cart-clicked',custId,sku, this.line_type )
         },
         removeFromCartClicked(custId, sku){
             this.$emit('remove-from-cart-clicked',custId,sku,this.line_type )
         },
         makeReservationClicked(custId, lineId){
             this.$emit('make-reservation-clicked', custId, lineId)
         },
         makeBackorderClicked(custId, lineId) {
             this.$emit('make-backorder-clicked', custId,lineId )
         },
         cancelBackorderClicked(custId, lineId) {
             this.$emit('cancel-backorder-clicked', custId,lineId )
         },
         makeReturnClicked(custId, lineId) {
             this.$emit('make-return-clicked', custId,lineId )
         },
         cancelReturnClicked(custId, lineId) {
             this.$emit('cancel-return-clicked', custId,lineId )
         },
         getFilteringState(filter, categoryState){
             if(filter.length >= 2){
                 return categoryState
             }else{
                 return false
             }
         },
         addFocusProduct(sku, price){
             this.$emit('add-focus-product', sku,price)
         },
         addReplacementProduct(sku){
            this.$emit('add-replacement-product', sku)
         },
         removeFocusProduct(sku){
             this.$emit('remove-focus-product', sku)
         },
         releaseReservationClicked(custId, lineId){
             this.$emit('release-reservation-clicked', custId, lineId)
         },
         isExpanded(category){
             if(category.filteredStatus){
                 this.expanded.length = 0
                 return false
             }
             return this.expanded.indexOf(category.id) > -1
         },
         isFiltered(category){
             if(category.filteredStatus){
                 return true
             } else {
                 return false
             }
         },
         toggleExpand(catId){
             if(this.expanded.includes(catId)){
                 this.collapse(catId)
             }else{
                 this.expand(catId)
             }
         },
         expand(catId){
             this.expanded.push(catId)
         },
         products(cat){
             if(cat.filteredStatus){
                 //console.log("products(cat) returning filtered products list: " + cat.filteredProds.length);

                 if(cat.filteredProds){
                     return Object.values(cat.filteredProds)

                 }else{
                     return []
                 }
             }
             //console.log("Giving up and returning full products list");
             return Object.values(cat.products)
         },

         collapse(catId){
             let index = this.expanded.indexOf(catId)
             if (index > -1) {
                 this.expanded.splice(index, 1);
             }
         }
     },


     setup(){
         const categories = ref(0)
         const store = useStore()
         const filteredCats = ref([])
         const filtered = ref("")
         const filteredVal = ref("")
         const loading = ref(true)
         const prodTick = ref(0)
         const lowStockToggle = ref(false)
         store.dispatch('loadAllCategories').then(()=>{
             store.dispatch('loadAllProducts').then(()=>{
                 //will need to consider not being hardcoded
                 store.dispatch('loadProductStock')
                 const cats = store.getters.categories
                 
                 
                 cats.map((cat)=>{
                     if(parseInt(cat.id) === 1157){
                         categories.value = cat.children
                         loading.value = false
                     }
                 })
                 
             })
         })

         function watchFilter(newString, lowstocklist){
             store.dispatch('loadAllCategories').then(()=>{
                 store.dispatch('loadAllProducts').then(()=>{
                     //will need to consider not being hardcoded
                     const cats = store.getters.categories

                     cats.map((cat)=>{
                         if(parseInt(cat.id) === 1157){
                             let arr = []
                             let catArr = []

                             cat.children.map((subCat)=>{
                                 let prods  = store.getters.getActiveProductCollection(subCat.products)

                                 let filteredProds = []
                                 if(newString.length >= 2 && lowStockToggle.value === true){
                                     //console.log("1. both filters Pushing ");
                                     prods.map((prod)=>{
                                         if (lowstocklist.indexOf(prod.SKU) > -1) {
                                             if (prod.salesName.toUpperCase().indexOf(newString.toUpperCase()) >= 0 || prod.SKU.toString().toUpperCase().indexOf(newString.toString().toUpperCase()) >= 0) {
                                                 if (prod.salesName.toUpperCase().indexOf(newString.toUpperCase()) >= 0) {
                                                     //console.log("1. both filters Pushing " + prod.SKU + " after hit on 1 for " + newVal);
                                                 }
                                                 if (prod.SKU.toString().toUpperCase().indexOf(newString.toString().toUpperCase()) >= 0) {
                                                     //console.log("Pushing " + prod.SKU + " after hit on 2 for " + newVal);
                                                 }

                                                 filteredProds.push(prod.SKU)
                                             }
                                         }
                                     })
                                 }else if(newString.length >= 2 && lowStockToggle.value === false){
                                     //console.log("2. newVal >=2, lowstock false ")
                                     prods.map((prod) => {
                                         if (prod.salesName.toUpperCase().indexOf(newString.toUpperCase()) >= 0 || prod.SKU.toString().toUpperCase().indexOf(newString.toString().toUpperCase()) >= 0) {
                                             if (prod.salesName.toUpperCase().indexOf(newString.toUpperCase()) >= 0) {
                                                 //console.log("2. newVal filter low false filters Pushing " + prod.SKU + " after hit on 1 for " + newVal);
                                             }
                                             if (prod.SKU.toString().toUpperCase().indexOf(newString.toString().toUpperCase()) >= 0) {
                                                 //console.log("Pushing " + prod.SKU + " after hit on 2 for " + newVal);
                                             }

                                             filteredProds.push(prod.SKU)
                                         }
                                     })
                                 } else if(lowStockToggle.value === true && newString.length <= 1){
                                     //console.log("3. newVal == 1 or 0, lowstock true ")
                                     prods.map((prod)=>{
                                         if (lowstocklist.indexOf(prod.SKU) > -1) {
                                             filteredProds.push(prod.SKU)
                                         }

                                     })
                                 }else {
                                     //console.log("4. for newVal = 1 and lowstock false")
                                     store.dispatch('loadAllCategories').then(() => {
                                         store.dispatch('loadAllProducts').then(() => {
                                             //will need to consider not being hardcoded
                                             const cats = store.getters.categories
                                             cats.map((cat) => {
                                                 if (parseInt(cat.id) === 1157) {

                                                     categories.value = cat.children
                                                     loading.value = false
                                                 }
                                             })

                                         })
                                     })
                                 }
                                 if(filteredProds.length > 0){
                                     let target = {
                                         name:subCat.name,
                                         products:subCat.products,
                                         id:subCat.id,
                                         filteredProds:filteredProds,
                                         filteredStatus:true
                                     }
                                     catArr.push(target)
                                 }
                             })
                             //console.log("End of filter (cat) : ",filteredCats);
                             //console.log("End of filter (prod): ",filteredProds);
                             filteredCats.value = arr
                             categories.value = catArr
                             loading.value = false

                         }
                     })

                 })
             })
         }

         watch(lowStockToggle, (lowStockToggle) => {
             //console.log(`toggle is ${lowStockToggle}`)
             loading.value = true;
             let list = store.getters.getLowStockList();

             prodTick.value += 1;
             let newVal = filteredVal.value;

             if (lowStockToggle === true  || newVal.length >= 1) {
                 watchFilter(newVal, list)

             } else {
                 //console.log("5. filter passed else block")
                 store.dispatch('loadAllCategories').then(() => {
                     store.dispatch('loadAllProducts').then(() => {
                         //will need to consider not being hardcoded
                         const cats = store.getters.categories
                         cats.map((cat) => {
                             if (parseInt(cat.id) === 1157) {

                                 categories.value = cat.children
                                 loading.value = false
                             }
                         })

                     })
                 })
             }

         })


         watch(filtered,(newVal) => {
             loading.value = true;
             prodTick.value += 1;
             filteredVal.value = newVal;
             let list = store.getters.getLowStockList();

             //console.log(`toggle is ${lowStockToggle.value}`);
             if(newVal.length  >= 1 || lowStockToggle.value === true){
                 watchFilter(newVal, list)

             }else{
                 //console.log("5. filter passed else block")
                 store.dispatch('loadAllCategories').then(()=>{
                     store.dispatch('loadAllProducts').then(()=>{
                         //will need to consider not being hardcoded
                         const cats = store.getters.categories
                         cats.map((cat)=>{
                             if(parseInt(cat.id) === 1157){

                                 categories.value = cat.children
                                 loading.value = false
                             }
                         })

                     })
                 })
             }
         })




         return {categories, filtered, filteredCats,filteredVal,loading,prodTick,lowStockToggle}
     }
 }
</script>

<style scoped>

</style>
